var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisibility = function SvgVisibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 20.69,
    y1: 143.39,
    x2: 164.69,
    y2: 36.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -3.4,
    y1: 110.98,
    x2: 140.6,
    y2: 3.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -15.75,
    y1: 94.36,
    x2: 128.25,
    y2: -12.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 35.19,
    y1: 162.91,
    x2: 179.19,
    y2: 55.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 39.93,
    y1: 169.28,
    x2: 183.93,
    y2: 62.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 40.3,
    y1: 169.79,
    x2: 184.3,
    y2: 62.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 39.92,
    y1: 169.28,
    x2: 183.92,
    y2: 62.28,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M74.51,109.82c-1.79,0-3.51-.75-4.72-2.06-1.1-1.19-1.71-2.74-1.71-4.36,0-3.55,2.88-6.43,6.43-6.43,1.23,0,2.42.35,3.45,1.01,1.87,1.19,2.98,3.21,2.98,5.42,0,3.54-2.88,6.42-6.43,6.42M74.51,101.33c-1.14,0-2.08.93-2.08,2.08,0,.52.2,1.02.55,1.41,1.18,1.27,3.6.32,3.6-1.41,0-.71-.36-1.37-.97-1.75h-.01c-.32-.22-.7-.33-1.1-.33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100,54.69c-3.61,0-6.53-2.92-6.53-6.53v-28.04c0-3.6,2.92-6.53,6.53-6.53s6.53,2.92,6.53,6.53v28.04c0,3.6-2.92,6.53-6.53,6.53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.42,77.09c-1.67,0-3.34-.64-4.62-1.91l-18.03-18.03c-2.55-2.55-2.55-6.68,0-9.23s6.68-2.55,9.23,0l18.03,18.03c2.55,2.55,2.55,6.68,0,9.23-1.27,1.27-2.95,1.91-4.62,1.91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.58,77.09c-1.67,0-3.34-.64-4.62-1.91-2.55-2.55-2.55-6.68,0-9.23l18.03-18.03c2.55-2.55,6.68-2.55,9.23,0s2.55,6.68,0,9.23l-18.03,18.03c-1.27,1.27-2.95,1.91-4.62,1.91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100,186.4c-59.11,0-97.3-55.74-98.89-58.12-1.48-2.2-1.48-5.08,0-7.28,1.59-2.38,39.77-58.12,98.89-58.12s97.29,55.74,98.89,58.12c1.48,2.2,1.48,5.08,0,7.28-1.6,2.38-39.77,58.12-98.89,58.12M14.64,124.64c9.25,11.89,41.46,48.71,85.36,48.71s76.1-36.82,85.35-48.71c-9.25-11.89-41.46-48.71-85.35-48.71S23.89,112.76,14.64,124.64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100,165.16c-22.34,0-40.52-18.18-40.52-40.52l.09-2.62s.03-.47.03-.51l.39-3.27c0-.09.07-.44.13-.81l12.87,2.2c-.01.1-.13.8-.15.89l-.18,1.5h0l-.04.48-.08,2.14c0,15.14,12.32,27.47,27.46,27.47,1.87,0,3.73-.19,5.53-.56.9-.18,1.78-.41,2.64-.67.85-.27,1.7-.57,2.52-.92.37-.16.75-.33,1.13-.51,2.28-1.09,4.4-2.49,6.3-4.16.47-.41.9-.82,1.31-1.24.46-.46.91-.94,1.34-1.44.59-.67,1.11-1.34,1.61-2.04.3-.44.54-.77.76-1.12l.34-.54c.26-.43.47-.8.68-1.19,2.16-3.98,3.31-8.5,3.31-13.08,0-15.14-12.32-27.46-27.46-27.46l-1.25.03c-.08,0-.6.03-.67.03-.04,0-.4.03-.44.03-.03,0-.58.06-.61.06-.16.03-.97.13-1.14.14-.12.02-.37.07-.49.08,0,0-.5.09-.52.1-.05,0-.48.1-.54.11l-2.96.79s-.84.3-.86.3c-3.36,1.3-7.3-.3-8.6-3.66-1.31-3.36.2-7.08,3.56-8.39l7.8-2.12c.08-.01.48-.08.56-.09l.49-.07s.04,0,.06,0l2.33-.26c.06,0,.41-.03.47-.03-.15-.04.16-.01.43-.02l2.38-.07c22.34,0,40.52,18.18,40.52,40.51,0,6.75-1.7,13.43-4.9,19.32-.31.57-.64,1.14-.97,1.69l-.52.84c-.31.49-.65.98-.99,1.47-.86,1.21-1.66,2.22-2.51,3.2-.61.7-1.27,1.42-1.97,2.11-.63.63-1.28,1.24-1.95,1.82-2.78,2.45-5.91,4.52-9.25,6.11-.54.26-1.1.51-1.68.76-1.22.51-2.46.97-3.73,1.36-1.28.4-2.58.74-3.9,1.01-2.65.55-5.4.82-8.15.82"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100,143.91c-10.62,0-19.27-8.64-19.27-19.27s8.65-19.27,19.27-19.27,19.27,8.64,19.27,19.27-8.65,19.27-19.27,19.27M100,118.42c-3.43,0-6.22,2.79-6.22,6.22s2.79,6.22,6.22,6.22,6.22-2.79,6.22-6.22-2.79-6.22-6.22-6.22"
  })));
};
export default SvgVisibility;